export const invoiceFilterCategories = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show Only Force Invoices' },
  { value: 2, label: 'Show Only Over Spending Limit' },
  { value: 3, label: 'Show Only Over Budget' },
  { value: 4, label: 'Show Only Not in a Current Budget Period' },
  { value: 5, label: 'Show Only Buyer Notes' },
  { value: 6, label: 'Show Only Invoices' },
  { value: 7, label: 'Show Only Credits' },
  { value: 8, label: 'Show Only Qty Received < 100%' },
  { value: 9, label: 'Show Only Qty Received >= 100%' },
];
